module.exports = function (it) {
  return typeof it === 'object' ? it !== null : typeof it === 'function';
};



//////////////////
// WEBPACK FOOTER
// C:/Source/hackathon/hackathon/web-app/node_modules/core-js/modules/_is-object.js
// module id = ../../../node_modules/core-js/modules/_is-object.js
// module chunks = 0